import React, {useState} from 'react'
import { graphql, Link } from 'gatsby'
import { withStyles } from '@material-ui/core/styles'
import Layout from '../components/layoutV2'
import SEO from '../components/seo'
import LayoutInner from '../components/layoutInnerV2'
import * as PATHS from '../utils/paths'
import { ArticleSnippet } from '../components/ArticleSnippet4'
import {joinPaths} from "../utils";
import {
    GridColHalfontent,
    GridColLeftContent,
    GridColMainContent,
    GridColQuarterContent,
    GridColThirdContent, GridColThreeQuartersContent, GridColTwoThirdsContent,
    GridContainer
} from "../components/GridStuff";
import {Header3, Header5, PBody1, textColorDark} from "../components/type";
import {MARGIN_SIZE, MARGIN_SIZE_SM_DOWN, SMALL_DOWN_MEDIA_QUERY} from "../components/constants";
import {Button} from "@material-ui/core";
import {SectionContainer} from "../components/SectionContainer";

const blogIndexStyles = theme => ({
    root: {},
    heroSection: {
        marginTop: MARGIN_SIZE,
        marginBottom: 2 * MARGIN_SIZE,

        [SMALL_DOWN_MEDIA_QUERY]: {
            marginBottom: MARGIN_SIZE_SM_DOWN,
        }

    },
    title: {
        color: textColorDark,
        fontFamily: "anext",
        fontWeight: 600,

        hyphens: "manual",
        marginTop: 0,
        marginBottom: 24,

        fontSize: 40,
        lineHeight: "48px",
        letterSpacing: -.86,


        [SMALL_DOWN_MEDIA_QUERY]: {

        },
    },
    subheroText: {
        fontSize: 21,
        lineHeight: "32px",
        fontWeight: 400,
        marginBottom: 24
    },
    postsSection: {
        marginTop: 16
    },
    headImgWrap: {
        position: "relative",
        display: "flex",
        flexDirection: "column",
        backgroundColor: "#F2f2f2",
        aspectRatio: 100/150,
        [SMALL_DOWN_MEDIA_QUERY]: {
            display: "none"
        },
    },
    headImgHor: {
        display: "none",
        [SMALL_DOWN_MEDIA_QUERY]: {
            display: "block",
            maxWidth: "33%",

            marginBottom: 24,

        },
    },
    headImgVert: {
        position: "absolute",
        mixBlendMode: "multiply",
        maxWidth: "110%",
        top: -36,
        left: -12,
        right: -12,

        [SMALL_DOWN_MEDIA_QUERY]: {
            display: "none"
        },
    },

});

const _BlogIndex = ({data, location, classes}) => {
    const siteTitle = data.site.siteMetadata.title
    const posts = data.allMarkdownRemark.edges

    const [blogItemCount, setBlogItemCount] = useState(7)
    const blogItems = posts.filter(p => !p.node.frontmatter.hide).filter(p => p.node.fields.collection === `blog`)
    const totalBlogItems = blogItems.length


    const [workItemCount, setWorkItemCount] = useState(7)
    const workItems = posts.filter(p => !p.node.frontmatter.hide).filter(p => p.node.fields.collection === `work`)
    const totalWorkItems = workItems.length

    return (
        <Layout location={location} title={siteTitle}>
            <SEO title={"3iap | Human-Centered Data Design"}/>

            <LayoutInner>

                <GridContainer className={classes.heroSection}>
                    <GridColHalfontent>
                        <div >
                            <img className={classes.headImgHor}
                                 src={"https://3iap.com/cdn/images/3iap-hero-flower-hor-v01.png"}/>
                        </div>

                        <h1 className={classes.title}>
                            3iap helps clients research, design, and develop psycho&shy;logically effective, safe,
                            <span style={{color: "#467086"}}> humanistic data visualization.</span>
                        </h1>
                        {/*<div style={{height: 12}}/>*/}
                        <PBody1>
                            3iap's approach to data communication is outcome-driven, centered on thoughtful analysis,
                            and deeply rooted in the science of visualization.
                        </PBody1>
                        {/*<div style={{height: 96}}/>*/}


                    </GridColHalfontent>

                    <GridColHalfontent>
                        <div className={classes.headImgWrap} style={{}}>
                            <div className={classes.headImgVertBack}></div>
                            <img className={classes.headImgVert}
                                 src={"https://3iap.com/cdn/images/3iap-hero-flower-vert-v02.png"}/>
                            <br/><br/>
                        </div>
                    </GridColHalfontent>


                </GridContainer>


                <GridContainer>


                    <GridColQuarterContent>
                        <hr/>
                        <div style={{height: 24}}/>
                    </GridColQuarterContent>
                </GridContainer>


                <GridContainer>


                    <GridColMainContent>
                        <Header5>
                            Selected Projects
                        </Header5>
                        {/*<div style={{height: 12}}/>*/}
                        {/*<PBody1>*/}
                        {/*    The essays below highlight examples of psychologically effective data design. They include*/}
                        {/*    empirical findings from our own work and others', each with a different lens on the*/}
                        {/*    surprising ways that data can make a difference.*/}
                        {/*</PBody1>*/}
                    </GridColMainContent>
                    <GridColLeftContent></GridColLeftContent>
                </GridContainer>

                <div style={{height: 48}}/>


                <GridContainer>

                    {/*<GridColHalfontent>*/}
                    {/*    /!*<p>Hello world</p>*!/*/}
                    {/*    <ArticleSnippet path={workItems[0].node.fields.slug}*/}
                    {/*                    title={workItems[0].node.frontmatter.title}*/}
                    {/*                    node={workItems[0].node}/>*/}
                    {/*    /!*{1<=workItems.length &&*!/*/}
                    {/*    /!*    (<ArticleSnippet path={workItems[0].node.fields.slug} title={workItems[0].node.frontmatter.title} node={workItems[0].node}/>)}*!/*/}
                    {/*</GridColHalfontent>*/}

                    {posts.filter(p => !p.node.frontmatter.hide)
                        .filter(p => p.node.fields.collection === `work`)
                        .slice(0, workItemCount)
                        .map(({node}, i) => {
                            const title = node.frontmatter.title || node.fields.slug
                            return (
                                <GridColQuarterContent>
                                    <ArticleSnippet key={i} path={"/work" + node.fields.slug} title={title} node={node}/>
                                </GridColQuarterContent>

                            )
                        })}
                    {workItemCount < totalWorkItems && (
                        <GridColQuarterContent>
                            <div style={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                                height: "100%",
                                maxHeight: 192,
                                // marginTop: 48
                            }}

                            >
                                <Button variant={"outlined"} color={"secondary"}
                                        fullWidth
                                        onClick={() => {
                                            setWorkItemCount(workItemCount + 4)
                                        }}
                                        style={{height: "100%"}}
                                >Show More Projects</Button>
                            </div>
                            {/*<div style={{height: 48}}/>*/}


                        </GridColQuarterContent>
                    )}

                </GridContainer>


                <div style={{height: 96}}/>

                <GridContainer>
                    <GridColQuarterContent>
                        <hr/>
                        <div style={{height: 24}}/>
                    </GridColQuarterContent>
                </GridContainer>

                <GridContainer>
                    <GridColThreeQuartersContent>
                        <Header5>
                            Research & Writing
                        </Header5>
                        <div style={{height: 24}}/>
                        <PBody1>
                            The essays below highlight examples of psychologically effective data design. They include
                            empirical findings from our own work and others', each with a different lens on the
                            surprising ways that data can make a difference.
                        </PBody1>
                    </GridColThreeQuartersContent>
                    <GridColLeftContent></GridColLeftContent>
                </GridContainer>

                <div style={{height: 48}}/>


                <GridContainer style={{rowGap: 0}}>

                    {posts.filter(p => !p.node.frontmatter.hide)
                        .filter(p => p.node.fields.collection === `blog`)
                        .slice(0, blogItemCount)
                        .map(({node}, i) => {
                            const title = node.frontmatter.title || node.fields.slug
                            return (
                                <GridColQuarterContent key={i}>
                                    <ArticleSnippet key={i} path={node.fields.slug} title={title} node={node}/>
                                </GridColQuarterContent>
                            )
                        })}
                    {blogItemCount < totalBlogItems && (
                        <GridColQuarterContent>
                            <div style={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                                height: "100%",
                                maxHeight: 192,
                            }}

                            >
                                <Button variant={"outlined"} color={"secondary"}
                                        fullWidth
                                        onClick={() => {
                                            setBlogItemCount(blogItemCount + 4)
                                        }}
                                        style={{height: "100%"}}
                                >Show More Writing</Button>
                            </div>
                            {/*<div style={{height: 48}}/>*/}


                        </GridColQuarterContent>
                    )}

                </GridContainer>

                <div style={{height: 96}}/>

                <GridContainer>
                    <GridColThirdContent>
                        <hr/>
                        <div style={{height: 24}}/>
                        <Header5>
                            Clients, Partners, Recognition
                        </Header5>
                        <div style={{height: 48}}/>
                    </GridColThirdContent>
                    <GridColTwoThirdsContent>
                        <img style={{maxWidth: "100%"}} src={joinPaths([PATHS.CDN, "images/3iap-logo-wall.png"])}/>


                        <div style={{height: 40}}/>
                        <hr/>
                        <div style={{height: 48}}/>
                        <img style={{maxWidth: "100%"}} src={joinPaths([PATHS.CDN, "images/3iap-featured-in.png"])}/>
                    </GridColTwoThirdsContent>

                </GridContainer>

                <div style={{height: 96}}/>

            </LayoutInner>

        </Layout>
    )
}

export const BlogIndex = withStyles(blogIndexStyles)(_BlogIndex)
export default BlogIndex

export const pageQuery = graphql`
  query {
    site {
      siteMetadata {
        title
      }
    }
    allMarkdownRemark(sort: { fields: [frontmatter___date], order: DESC }) {
      edges {
        node {
          excerpt
          fields {
            slug
            collection
          }
          frontmatter {
            title
            description
            readTime
            hide
            featuredImageAltText
            featuredImageBGColor
          }
        }
      }
    }
  }
`
